// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__SrvvS","rightAdornment":"Header_rightAdornment__rUjBq"};